export default {
  enter: 'Enter',
  space: ' ',
};
